import { Component, inject, Signal, ViewChild } from '@angular/core';
import { Queue } from '../../models/queue/queue.model';
import { Store } from '@ngxs/store';
import { QueueState } from '../../store/queue/queue.state';
import {
  DeleteBorrowerFromUserQueue,
  UpdateUserQueue,
  ClearUserQueue
} from '../../store/queue/queue.actions';
import { QueueComponent } from '../queue/queue.component';

@Component({
  selector: 'app-queue-smart',
  templateUrl: './queue-smart.component.html',
  styleUrls: ['./queue-smart.component.scss'],
  standalone: false
})
export class QueueSmartComponent {
  store = inject(Store);
  queue: Signal<Queue[]> = this.store.selectSignal(QueueState.queue);

  @ViewChild('queueComponent', { static: true })
  queueComponent: QueueComponent;

  constructor() { }

  handleDeleteBorrowerFromUserQueue(borrowerId: number) {
    this.store.dispatch(new DeleteBorrowerFromUserQueue(borrowerId));
  }

  handleUpdateQueue(updatedItem: { borrowerIndex: number, position: number }) {
    this.store.dispatch(new UpdateUserQueue(updatedItem.borrowerIndex, updatedItem.position));
  }

  handleClearUserQueue() {
    this.store.dispatch(new ClearUserQueue(true));
  }
}
